// ============================================================
// 法律页面共享布局（隐私政策 / 服务条款）
//
// 两个页面结构一致：标题 + 更新时间 + 引言 + 分节正文，
// 全部文案走 i18n；支持邮箱通过 {email} 插值注入
// ============================================================

import { useI18n } from '../i18n';
import type { TranslationKey } from '../i18n/translations';
import { SUPPORT_EMAIL } from '../lib/config';

export interface LegalSection {
  title: TranslationKey;
  paragraphs: TranslationKey[];
}

export default function LegalPage({
  title,
  updated,
  intro,
  sections,
}: {
  title: TranslationKey;
  updated: TranslationKey;
  intro: TranslationKey;
  sections: LegalSection[];
}) {
  const { t } = useI18n();

  return (
    <div className="page-wrap legal-page">
      <h1 className="page-title-lg">{t(title)}</h1>
      <p className="legal-updated">{t(updated)}</p>
      <p className="legal-intro">{t(intro)}</p>

      {sections.map((section) => (
        <section className="legal-section" key={section.title}>
          <h2>{t(section.title)}</h2>
          {section.paragraphs.map((p) => (
            <p key={p}>{t(p, { email: SUPPORT_EMAIL })}</p>
          ))}
        </section>
      ))}
    </div>
  );
}
